export const ZIPRECRUITER_CARD_IMAGE_SRC = '/next-assets/images/ziprecruiter-job-logo.jpg'
